import React from 'react';
import { clickableProps, CLICKABLE_CARD } from '../../utils/clickable';
import { cardClass, cardTone, CARD_LABEL, CARD_NOTE } from '../UI/dashboardCard';

/**
 * ChartCard — a chart (or a table) in the dashboard's card look: the figure,
 * its label and a note centred over the chart, as on the dashboards.
 *
 *   label         {string}          — what the chart shows
 *   value         {ReactNode}       — optional big figure over the label
 *   subtitle      {ReactNode}       — optional note under the label
 *   color         {string}          — the bar and figure colour (dashboardCard)
 *   onClick       {function}        — optional: the card opens what it shows
 *   title         {string}          — optional tooltip (where a click goes)
 *   bodyClassName {string}          — e.g. 'h-64' for a chart that fills it
 *   flush         {boolean}         — no side padding (a table to the edges)
 */
const ChartCard = ({ label, value = null, subtitle = null, color = 'blue', onClick = null, title, bodyClassName = '', flush = false, className = '', children }) => (
  <div
    {...clickableProps(onClick, title)}
    title={title}
    className={`${cardClass(color)} overflow-hidden flex flex-col ${onClick ? CLICKABLE_CARD : ''} ${className}`}
  >
    <div className="px-4 pt-5 pb-3 flex flex-col items-center text-center">
      {value !== null && value !== undefined && (
        <span className={`text-2xl font-bold leading-none mb-1 ${cardTone(color).value}`}>{value}</span>
      )}
      <span className={CARD_LABEL}>{label}</span>
      {subtitle && <span className={CARD_NOTE}>{subtitle}</span>}
    </div>
    <div className={`flex-1 min-h-0 ${flush ? '' : 'px-4 pb-4'} ${bodyClassName}`}>{children}</div>
  </div>
);

export default ChartCard;
